import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { format, addDays } from 'date-fns'
import { detectSafari } from 'base/lib/device'
import moment from 'moment-timezone'

import Input from 'base/react/components/form/input'
import FlatButton from 'base/react/components/flat_button'
import LoadingAnimation from 'base/react/components/loading_animation'

const ALLOWED_MESSAGE_LENGTH = 240

class GiftcardForm extends Component {
  static defaultProps = {
    errors: {},
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    isLoading: PropTypes.bool,
    errors: PropTypes.object,
    presetValues: PropTypes.object,
  }

  state = {
    recipientEmail: this.props.presetValues?.recipient_email || '',
    recipientName: this.props.presetValues?.recipient_name || '',
    deliveryDate: null,
    message: this.props.presetValues?.message || '',
  }

  componentDidMount() {
    this.setState({
      deliveryDate: this.determineDate(),
    })
  }

  determineDate = () => {
    if (this.props.presetValues?.notify_at) {
      const date = new Date(this.props.presetValues.notify_at)
      const timezoneOffset = date.getTimezoneOffset() * 60000
      const localDatetime = new Date(date - timezoneOffset).toISOString().split('.')[0]

      if (detectSafari()) {
        return format(addDays(new Date(localDatetime), 1), 'MM/dd/yyyy')
      } else {
        return localDatetime
      }
    } else {
      return ''
    }
  }

  prepareStateForSubmission = () => {
    const preparedState = { ...this.state }
    if (detectSafari()) {
      let dateFormat = 'MM/dd/yyyy'
      if (this.props.presetValues?.recipient_name) {
        // due to how we massage this data on the way to the server
        // (and because of how Safari manages dates by default),
        // updating and creating require different date formats
        dateFormat = 'yyyy-MM-dd'
      }

      try {
        preparedState.deliveryDate = format(
          new Date(Date.parse(preparedState.deliveryDate)),
          dateFormat,
        )
      } catch (error) {
        preparedState.deliveryDate = ''
      }
    }
    return preparedState
  }

  handleSubmit = event => {
    event.preventDefault()
    this.props.onSubmit?.(this.prepareStateForSubmission())
  }

  handleFieldChange = field => event => {
    this.setState({ [field]: event.target.value })
  }

  renderNameField() {
    return (
      <Input
        label="Recipient Name"
        error={this.props.errors.recipientName}
        placeholder="Annie Clark"
        type="text"
        value={this.state.recipientName}
        onChange={this.handleFieldChange('recipientName')}
      />
    )
  }

  renderEmailField() {
    return (
      <Input
        label="Recipient Email"
        error={this.props.errors.recipientEmail}
        placeholder="annie@example.com"
        type="email"
        value={this.state.recipientEmail}
        onChange={this.handleFieldChange('recipientEmail')}
      />
    )
  }

  renderDateField() {
    const timezoneAbbr = moment().tz(moment.tz.guess()).format('z')

    return (
      <Input
        inputClass={classNames('giftcard-reservation__form__date-input', {
          'has-value': this.state.deliveryDate,
        })}
        label={`Delivery Date & Time (${timezoneAbbr})`}
        error={this.props.errors.deliveryDate}
        placeholder="Select Date & Time"
        type="datetime-local"
        dateFormat="mm/dd/yyyy"
        value={this.state.deliveryDate}
        onChange={this.handleFieldChange('deliveryDate')}
      />
    )
  }

  renderMessageField() {
    return (
      <Fragment>
        <Input
          label="Message (optional)"
          error={this.props.errors.message}
          placeholder="Didn't know your size. Happy Birthday, Annie!"
          type="textarea"
          value={this.state.message}
          onChange={this.handleFieldChange('message')}
        />
        <div className="giftcard-reservation__form__character-count">{`You have ${
          ALLOWED_MESSAGE_LENGTH - this.state.message.length
        } out of ${ALLOWED_MESSAGE_LENGTH} characters left`}</div>
      </Fragment>
    )
  }

  render() {
    return (
      <form className="giftcard-reservation__form">
        {this.renderNameField()}
        {this.renderEmailField()}
        {this.renderDateField()}
        {this.renderMessageField()}
        {this.props.isLoading ? (
          <LoadingAnimation />
        ) : (
          <FlatButton fullWidth onClick={this.handleSubmit} color="dark-grey">
            Save
          </FlatButton>
        )}
      </form>
    )
  }
}

export default GiftcardForm
